var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_2684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 33.401V25.7858C0.00585938 25.0361 0.312051 24.3172 0.857075 23.7872C1.4021 23.2571 2.14131 22.9593 2.91209 22.9593H23.0855C24.6196 22.9593 25.0783 24.9782 23.6854 25.6142L2.64015 35.0444C2.35673 35.1683 2.046 35.2215 1.7361 35.1992C1.42621 35.1769 1.12693 35.0797 0.86537 34.9165C0.60381 34.7534 0.38823 34.5293 0.23815 34.2647C0.0880698 34.0001 0.00822974 33.7032 0.00585938 33.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6062 29.5147V34.4306C31.6062 34.9125 31.4093 35.3747 31.059 35.7155C30.7086 36.0562 30.2334 36.2476 29.7379 36.2476H16.1201C15.8245 36.2546 15.5355 36.1615 15.3025 35.9843C15.0696 35.8071 14.9072 35.5567 14.843 35.276C14.7787 34.9952 14.8168 34.7014 14.9505 34.4449C15.0842 34.1884 15.3054 33.985 15.5762 33.8694L28.9553 27.8693C29.2395 27.7422 29.552 27.6865 29.8641 27.7074C30.1762 27.7283 30.4779 27.825 30.7415 27.9888C31.0051 28.1526 31.2223 28.3781 31.373 28.6447C31.5237 28.9113 31.6032 29.2104 31.6041 29.5147H31.6062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 15.9498V7.3069C0.00585937 6.825 0.202697 6.36284 0.553069 6.02209C0.903442 5.68134 1.37865 5.4899 1.87415 5.4899H23.2557C23.5738 5.48923 23.8826 5.59446 24.1306 5.7881C24.3787 5.98174 24.5512 6.25213 24.6193 6.55431C24.6875 6.85649 24.6472 7.17226 24.5053 7.44911C24.3633 7.72596 24.1282 7.94722 23.839 8.0761L2.64015 17.6032C2.35609 17.7274 2.04461 17.7806 1.73405 17.7579C1.42348 17.7351 1.12368 17.6373 0.86191 17.4732C0.60014 17.3091 0.384705 17.0839 0.235197 16.8182C0.0856901 16.5525 0.00685423 16.2547 0.00585938 15.9518V15.9498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6059 12.0634V16.9794C31.6059 17.4613 31.4091 17.9235 31.0587 18.2642C30.7084 18.605 30.2331 18.7964 29.7376 18.7964H15.7587C15.4863 18.7956 15.2224 18.7046 15.0104 18.5383C14.7984 18.3721 14.6509 18.1405 14.5924 17.8818C14.5339 17.6231 14.5678 17.3528 14.6885 17.1153C14.8092 16.8779 15.0094 16.6875 15.2563 16.5756L28.9571 10.4281C29.2408 10.3029 29.5522 10.2486 29.863 10.2703C30.1737 10.2919 30.474 10.3888 30.7364 10.5522C30.9988 10.7155 31.2151 10.9401 31.3655 11.2054C31.5159 11.4708 31.5957 11.7685 31.5976 12.0715L31.6059 12.0634Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_2684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 31,
    fill: "white",
    transform: "translate(0 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.35e5692293fcc9cd2266e930e15f1097.svg";
export { ForwardRef as ReactComponent };